"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePasswordVerifyResetToken = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
function usePasswordVerifyResetToken() {
    const { data: user, isLoading, error, get } = (0, core_ui_1.useApiGet)('users/password/verify/reset-token');
    const doVerifyResetToken = (0, react_1.useCallback)((token) => {
        get({ token });
    }, [get]);
    return { user, isLoading, error, doVerifyResetToken };
}
exports.usePasswordVerifyResetToken = usePasswordVerifyResetToken;
//# sourceMappingURL=usePasswordVerifyResetToken.js.map